module.exports = __webpack_public_path__ + "img/sleepdevil.efc09cc1.jpg";